import { useQueryClient } from 'react-query';

import { QUOTE_DEFAULT_TYPES } from '@/common/constants';

const useSelectOption = (queryKey) => {
  const queryClient = useQueryClient();

  const mutate = ({ itemId, quoteLine, isSelected }) => {
    const previousData = queryClient.getQueryData(queryKey);

    return queryClient.setQueryData(queryKey, {
      ...previousData,
      quote_lines: previousData.quote_lines?.map((item) => {
        if (
          item.id === quoteLine &&
          item.type === QUOTE_DEFAULT_TYPES.PRODUCT &&
          item.options.length > 0
        ) {
          return {
            ...item,
            is_selected: !item.variants.find((variant) => variant.is_selected),
            options: item.options.map((option) => {
              if (option.id === itemId) {
                return {
                  ...option,
                  is_selected: isSelected,
                };
              }
              return option;
            }),
          };
        }
        return item;
      }),
    });
  };

  return {
    mutate,
  };
};

export default useSelectOption;
